import React, { Component } from 'react';

import withStyles from '@mui/styles/withStyles';
import PhoneInput from './PhoneInput';
import phoneInputStyle from '../assets/jss/crm/components/phoneInputStyle.jsx';
import ClickAwayListener from '@mui/material/ClickAwayListener';

class ClickAwayPhoneInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editing: false,
    };
  }

  handleOutsideClick = () => {
    this.setState({ editing: false });
    this.props.outsidePhoneClickHandler(this.props.index);
  };

  handleClickInEditableArea = () => {
    this.setState({ editing: true });
    this.props.onMouseDownInEditableArea(this.props.index);
  };

  render() {
    const { possibleRoles, actualRoles, number, onRolesChange, onNumberChange, index, styles } = this.props;

    return (
      <ClickAwayListener
        onClickAway={() => this.handleOutsideClick()}
        mouseEvent={this.state.editing ? 'onMouseDown' : false}
        touchEvent={this.state.editing ? 'onTouchStart' : false}
      >
        <PhoneInput
          possibleRoles={possibleRoles}
          actualRoles={actualRoles}
          number={number}
          onRolesChange={(rolesObj) => onRolesChange(rolesObj, index)}
          onNumberChange={(newNumber) => onNumberChange(newNumber, index)}
          onMouseDownInEditableArea={() => this.handleClickInEditableArea()}
          styles={styles}
        />
      </ClickAwayListener>
    );
  }
}

export default withStyles(phoneInputStyle)(ClickAwayPhoneInput);
